import { Sparkles } from 'lucide-react';
import { AiGenerateWithPromptDialog } from '@/components/ai-job/AiGenerateWithPromptDialog';

interface GenerateDescriptionActionProps {
  tourId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Dialog that generates a description for a tour.
 */
export function GenerateDescriptionAction({ tourId, open, onOpenChange }: GenerateDescriptionActionProps) {
  return (
    <AiGenerateWithPromptDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Generate Description"
      description={
        <>
          This will generate a description based on the tour&apos;s name,
          greater area, and attractions. Any existing description will be overwritten.
        </>
      }
      endpoint={`/tours/${tourId}/generate-description`}
      promptPurpose="tour_description"
      invalidateKeys={[['Tour', tourId]]}
      successMessage="Description generated successfully"
      errorFallback="Failed to generate description"
    />
  );
}

/** Icon used for the Generate Description action button. */
export const GenerateDescriptionIcon = Sparkles;
